
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/menu/dine-in",
      function () {
        return require("private-next-pages/menu/dine-in.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/menu/dine-in"])
      });
    }
  